import {  Container } from "@mui/material";
import { useAppDispatch, useAppSelector } from "app/hooks"
import Header from "components/header/Header";
import { getAgentList, selectAgentList, selectAgentListTotal } from "features/agentList/agentListSlice"
import React, { useState, useEffect, useCallback } from "react";
import SearchBar from "components/inputs/HolzfinderSearchBar";
import HolzfinderList from "components/list/HolzfinderList";
import { selectPageAgentList, selectRowsPerPageAgentList, setPageAgentList, setRowsPerPageAgentList } from "features/table/tableSlice";


interface rowInterface {
  id: string;
  company: string;
  eldat_reference_id: number;
  street: string;
  street_number: string;
  zip_code: string;
  city: string;
}

const tableHeaderList: string[] = ["Agent-Nr.","Eldat Referenz ID", "Firma", "Straße", "Hausnummer", "Postleitzahl", "Stadt", "Bearbeiten"]

export default function AgentList() {

  const [rowData, setRowData] = useState<rowInterface[]>([]);
  const [searchQuery, setSearchQuery] = React.useState("");
  const agentList = useAppSelector(selectAgentList);
  const agentListTotal = useAppSelector(selectAgentListTotal);
  const page = useAppSelector(selectPageAgentList)
  const rowsPerPage = useAppSelector(selectRowsPerPageAgentList)
  const dispatch = useAppDispatch();

  const receiveAgentList = useCallback((resetSearch: boolean) => {
    if (resetSearch) setSearchQuery("")
    dispatch(
      getAgentList({
        items_per_page: rowsPerPage,
        page: page + 1,
        search: resetSearch ? undefined : searchQuery,
      })
    );
  }, [dispatch, rowsPerPage, page, searchQuery]);

  useEffect(() => {
    receiveAgentList(false)
  }, [page, rowsPerPage, searchQuery, receiveAgentList])

  useEffect(() => {
    const mappedData = agentList.map(
      (agent) => ({
        id: agent.id,
        agent_number: agent.eldat_reference_id,
        eldat_reference_id: agent.county.eldat_reference_id,
        company: agent.company,
        street: agent.street,
        street_number: agent.street_number,
        zip_code: agent.zip_code,
        city: agent.city
      })
    );
    setRowData(mappedData);
  }, [agentList])
  useEffect(() => {
    dispatch(setPageAgentList(0));
  }, [dispatch, searchQuery]);
  return (
    <Container sx={{ pl: { lg: 12, md: 12, xs: 12 }, pt: 5 }} maxWidth="xl">
      <Header header="Agentenliste" />
      <SearchBar page={page} rowsPerPage={rowsPerPage} getListType={getAgentList} setSearchQuery={setSearchQuery} />

      <HolzfinderList
        listLengthTotal={agentListTotal}
        rowData={rowData}
        switchActive={false}
        tableHeaderList={tableHeaderList}
        setPage={setPageAgentList}
        setRowsPerPage={setRowsPerPageAgentList}
        page={page}
        rowsPerPage={rowsPerPage === undefined ? 10 : rowsPerPage}
        setAgent={true}
        isLotList={false}
      />
    </Container>
  )
}